<template>
  <div v-if="loaded" class="md-layout">
    <div
      class="md-layout-item md-medium-size-100"
      :class="type === 'salary' ? 'md-size-100' : 'md-size-60'"
    >
      <md-card id="expense-card">
        <md-card-header
          v-if="type === 'expense'"
          class="md-card-header-icon md-card-header-brand"
        >
          <div class="card-icon">
            <md-icon>request_page</md-icon>
          </div>

          <h4 class="title">Ulazna faktura</h4>
          <md-button
            class="md-just-icon md-round modal-default-button md-simple"
            @click="hideExpense"
          >
            <md-icon style="color: red">clear</md-icon>
          </md-button>
        </md-card-header>

        <md-card-header
          v-else-if="type === 'salary'"
          class="md-card-header-icon md-card-header-brand"
        >
          <div class="card-icon">
            <md-icon>euro_symbol</md-icon>
          </div>

          <h4 class="title">Plata</h4>
          <md-button
            class="md-just-icon md-round modal-default-button md-simple"
            @click="hideExpense"
          >
            <md-icon style="color: red">clear</md-icon>
          </md-button>
        </md-card-header>

        <md-card-header
          v-else-if="type === 'cash'"
          class="md-card-header-icon md-card-header-brand"
        >
          <div class="card-icon">
            <md-icon>payments</md-icon>
          </div>

          <h4 class="title">Gotovina</h4>
          <md-button
            class="md-just-icon md-round modal-default-button md-simple"
            @click="hideExpense"
          >
            <md-icon style="color: red">clear</md-icon>
          </md-button>
        </md-card-header>

        <md-card-content v-if="type === 'expense'" class="md-layout">
          <md-field
            class="md-layout-item md-size-25 md-large-size-25 md-small-size-100"
          >
            <label> Broj računa </label>
            <md-input v-model="expense.invoiceNumber" type="text"> </md-input>
          </md-field>

          <md-field
            class="md-layout-item md-size-25 md-large-size-75 md-small-size-100"
          >
            <search-drop-down
              :title="'Klijent'"
              :items="clients"
              :defaultValue="expense.client.name || ''"
              @updatedInput="searchClients"
              @selected="selectClient"
            />
          </md-field>
          <md-field
            class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
          >
            <label>Datum uplate</label>
            <md-datepicker v-model="expense.dateSigned" />
          </md-field>
          <md-field
            class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
          >
            <label>Vrsta troška</label>
            <md-select v-model="expense.expenseTypeId">
              <md-option
                v-for="(expenseType, index) in expenseTypes"
                :key="index"
                :value="expenseType.id"
                >{{ expenseType.name }}</md-option
              >
            </md-select>
          </md-field>

          <md-field
            class="md-layout-item md-size-20 md-large-size-33 md-small-size-100"
          >
            <label> Iznos € sa PDV-om </label>
            <md-input
              v-model="expense.amountToPay"
              type="number"
              step="0.01"
              min="0.01"
            >
            </md-input>
          </md-field>

          <md-field
            class="md-layout-item md-size-15 md-large-size-33 md-small-size-100"
          >
            <label> PDV % </label>
            <md-input
              v-model="vatInPercentage"
              type="number"
              step="1"
              min="0"
              max="100"
            >
            </md-input>
          </md-field>
          <md-field
            class="md-layout-item md-size-15 md-large-size-33 md-small-size-100"
          >
            <md-checkbox v-model="expense.notVat"> Nije PDV </md-checkbox>
          </md-field>

          <ValidationProviderExtended
            name="Link dokumenta"
            rules="website"
            className="md-layout-item md-size-50 md-large-size-100 md-small-size-100"
          >
            <label> Link dokumenta </label>
            <md-input v-model="expense.documentUrl" type="text"> </md-input>
          </ValidationProviderExtended>

          <md-field class="md-layout-item md-size-100">
            <label> Komentar </label>
            <md-textarea v-model="expense.comment"> </md-textarea>
          </md-field>
        </md-card-content>

        <md-card-content v-else-if="type === 'cash'" class="md-layout">
          <md-field
            class="md-layout-item md-size-10 md-large-size-50 md-small-size-100"
          >
            <label> Broj računa </label>
            <md-input v-model="expense.invoiceNumber" type="text"> </md-input>
          </md-field>

          <md-field
            class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
          >
            <search-drop-down
              :title="'Klijent'"
              :items="clients"
              :defaultValue="expense.client.name || ''"
              @updatedInput="searchClients"
              @selected="selectClient"
            />
          </md-field>
          <md-field
            class="md-layout-item md-size-15 md-large-size-50 md-small-size-100"
          >
            <label> Iznos € </label>
            <md-input
              v-model="expense.amountToPay"
              type="number"
              step="0.01"
              min="0.01"
            >
            </md-input>
          </md-field>
          <md-field
            class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
          >
            <label>Datum uplate</label>
            <md-datepicker v-model="expense.dateSigned" />
          </md-field>
          <md-field
            class="md-layout-item md-size-25 md-large-size-50 md-small-size-100"
          >
            <md-radio v-model="expense.direction" value="in">
              Zaduženje
            </md-radio>
            <md-radio v-model="expense.direction" value="out">
              Isplata
            </md-radio>
          </md-field>

          <md-field class="md-layout-item md-size-100">
            <label> Komentar </label>
            <md-textarea v-model="expense.comment"> </md-textarea>
          </md-field>
        </md-card-content>

        <md-card-content v-else-if="type === 'salary'" class="md-layout">
          <md-field
            class="md-layout-item md-size-30 md-large-size-50 md-small-size-100"
          >
            <search-drop-down
              :title="'Klijent'"
              :items="clients"
              :defaultValue="expense.client.name || ''"
              @updatedInput="searchClients"
              @selected="selectClient"
            />
          </md-field>

          <md-field
            class="md-layout-item md-size-15 md-large-size-50 md-small-size-100"
          >
            <label> Iznos € </label>
            <md-input
              v-model="expense.amountToPay"
              type="number"
              step="0.01"
              min="0.01"
            >
            </md-input>
          </md-field>

          <md-field
            class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
          >
            <label>Datum uplate</label>
            <md-datepicker v-model="expense.dateSigned" />
          </md-field>
          <md-field
            :class="expense.direction === 'out' ? 'md-size-15' : 'md-size-35'"
            class="md-layout-item md-large-size-50 md-small-size-100"
          >
            <md-radio v-model="expense.direction" value="in">
              Zaduženje
            </md-radio>
            <md-radio v-model="expense.direction" value="out">
              Isplata
            </md-radio>
          </md-field>

          <md-field
            class="md-layout-item md-size-20 md-large-size-50 md-small-size-100"
            v-if="expense.direction === 'out'"
          >
            <label> Sa Računa </label>
            <md-select v-model="expense.bankAccountId">
              <md-option
                v-for="bankAccount in bankAccounts"
                :key="bankAccount.id"
                :value="bankAccount.id"
              >
                {{ bankAccount.name }}
              </md-option>
            </md-select>
          </md-field>

          <md-field class="md-layout-item md-size-100">
            <label> Komentar </label>
            <md-textarea v-model="expense.comment"> </md-textarea>
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button class="md-success" @click="saveExpense">
            <md-icon> save </md-icon>
            Sačuvaj
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-size-20 md-medium-size-100">
      <md-card v-if="expense.expenseTypeId === 7">
        <md-card-header class="md-card-header-icon md-card-header-brand">
          <div class="card-icon">
            <md-icon>inventory</md-icon>
          </div>
          <h4 class="title">Materijal</h4>
        </md-card-header>
        <md-card-content>
          <md-field
            class="
              md-layout-item md-size-100 md-large-size-50 md-small-size-100
            "
          >
            <label>Vrsta Materijala</label>
            <md-select
              v-model="expense.material.materialTypeId"
              @input="updateMaterialCard"
            >
              <md-option
                v-for="(materialType, index) in materialTypes"
                :key="index"
                :value="materialType.id"
                >{{ materialType.material }}</md-option
              >
            </md-select>
          </md-field>

          <div
            v-if="expense.material.materialTypeId === 1"
            class="md-layout-item md-size-100"
          >
            <drop-down direction="down" multiLevel>
              <md-button
                slot="title"
                class="dropdown-toggle item-dropdown"
                :class="[expense.material.id ? 'md-primary' : 'md-inactive']"
                data-toggle="dropdown"
              >
                <span id="paperTypeLabel">{{
                  'Papir' +
                  (expense.material.label
                    ? ': ' +
                      expense.material.group +
                      ' ' +
                      expense.material.label
                    : '')
                }}</span>
              </md-button>
              <ul class="dropdown-menu">
                <li
                  v-for="(group, groupIndex) in paperTypes"
                  :key="groupIndex"
                  @click="toggleMultiLevel('papertype', groupIndex)"
                >
                  <a
                    class="dropdown-toggle"
                    :class="{ open: multiLevel === `papertype-${groupIndex}` }"
                    >{{ group.group }}</a
                  >
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li
                      v-for="(option, index) in group.list"
                      :key="index"
                      @click="selectOption(option, group.group)"
                    >
                      <a>{{ option.label }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </drop-down>
          </div>

          <div
            v-else-if="
              selectedMaterialType &&
              selectedMaterialType.list === 'miscellaneous'
            "
          >
            <md-field>
              <label>
                {{ selectedMaterialType.material }}
              </label>
              <search-drop-down
                :style="expense.material.id ? 'background-color: #c7d9ca' : ''"
                :title="'Ostalo'"
                :items="miscellaneousMaterials"
                :defaultValue="expense.material.label"
                @updatedInput="searchMiscellaneous"
                @selected="selectMaterial"
                @keyup.native="deselectMaterial"
              />
            </md-field>
          </div>

          <div
            v-else-if="
              selectedMaterialType && selectedMaterialType.unit === null
            "
          >
            <md-field>
              <label>
                {{ selectedMaterialType.material }}
              </label>
              <md-input v-model="expense.material.label" type="text">
              </md-input>
            </md-field>
          </div>

          <div
            v-else-if="
              selectedMaterialType && selectedMaterialType.list !== null
            "
          >
            <md-field>
              <label>
                {{ selectedMaterialType.material }}
              </label>
              <md-select v-model="expense.material.id">
                <md-option
                  v-for="(material, index) in materials"
                  :key="index"
                  :value="material.id"
                  >{{ material.name }}</md-option
                >
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <md-field v-if="selectedMaterialType && selectedMaterialType.unit">
              <label>
                Količina
                {{ selectedMaterialType ? selectedMaterialType.unit : '' }}
              </label>
              <md-input
                v-model="expense.material.amount"
                type="number"
                step="1"
                min="1"
              >
              </md-input>
            </md-field>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
export default {
  props: {
    expense: Object,
    type: String,
  },
  components: {
    ValidationProviderExtended,
  },
  computed: {
    vatInPercentage: {
      get() {
        return parseInt(this.expense.vat * 100);
      },
      set(value) {
        this.expense.vat = value / 100;
      },
    },
    selectedMaterialType() {
      return this.materialTypes.find((el) => {
        return el.id === this.expense.material.materialTypeId;
      });
    },
  },
  data() {
    return {
      clients: [],
      expenseTypes: [],
      materialTypes: [],
      bankAccounts: [],
      paperTypes: [],
      multiLevel: null,
      materials: [],
      miscellaneousMaterials: [],
      loaded: false,
    };
  },
  methods: {
    hideExpense() {
      this.$emit('hideExpense', true);
    },
    saveExpense() {
      const requestParams = Object.assign({}, this.expense);
      if (this.type === 'salary') {
        Object.assign(requestParams, {
          expenseTypeId: 6,
          invoiceNumber: 'plata',
          material: null,
          notVat: true,
          paymentType: 'cash',
          vat: 0.0,
        });
      } else if (this.type === 'cash') {
        Object.assign(requestParams, {
          expenseTypeId: 10,
          material: null,
          notVat: true,
          paymentType: 'cash',
          vat: 0.0,
        });
      }

      if (this.type !== 'salary' || this.expense.direction !== 'out') {
        delete requestParams.bankAccountId;
      }

      api
        .post(services.expenses.registerExpense, {
          registerExpenses: true,
          expense: JSON.stringify(requestParams),
        })
        .then((data) => {
          this.$notify({
            timeout: 2500,
            message: 'Ažurirana faktura ',
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success',
          });
          this.$emit('saveExpense', data.id);
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    searchClients(value) {
      return api
        .get(services.getClient, {
          loadClient: true,
          clientName: value,
          seller: true,
          employee: this.type === 'salary',
        })
        .then((data) => {
          this.clients = data;
        });
    },
    selectClient(value) {
      this.expense.client = value;
    },
    getExpenseTypes() {
      return api
        .get(services.getExpenseTypes, { loadExpenseTypes: true })
        .then((data) => {
          this.expenseTypes = data;
        });
    },
    getMaterialTypes() {
      return api
        .get(services.getMaterialTypes, { loadMaterialTypes: true })
        .then((data) => {
          this.materialTypes = data;
        });
    },
    selectOption(option, group) {
      Object.assign(this.expense.material, option);
      this.expense.material.group = group;
    },
    getPaperTypes() {
      api.get(services.paperTypes, { loadPaperTypes: true }).then((data) => {
        this.paperTypes = data;
      });
    },
    toggleMultiLevel(paramIndex, index) {
      this.multiLevel = `${paramIndex}-${index}`;
    },
    getBankAccounts() {
      return api
        .get(services.getBankAccounts, { loadBankAccounts: true })
        .then((data) => {
          this.bankAccounts = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getMaterials() {
      if (this.expense.material.materialTypeId) {
        const list = this.materialTypes.find((el, i) => {
          return (
            el.id === this.expense.material.materialTypeId ||
            i === this.materialTypes.length - 1
          );
        }).list;
        if (list) {
          api.get(services.getMaterials, { list }).then((data) => {
            this.materials = data;
          });
        }
      }
    },
    searchMiscellaneous(value) {
      this.expense.material.label = value;

      api
        .get(services.getMiscellaneousMaterials, {
          loadOtherMaterials: true,
          materialTypeId: this.selectedMaterialType.id,
          materialName: value,
        })
        .then((data) => {
          this.miscellaneousMaterials = data;
        });
    },
    updateMaterialCard() {
      if (this.expense.material.materialTypeId === 1) this.getPaperTypes();
      else this.getMaterials();

      if (this.miscellaneousMaterials) this.miscellaneousMaterials = [];
    },
    selectMaterial(value) {
      Object.assign(this.expense.material, value);
    },
    deselectMaterial() {
      this.expense.material.id = null;
    },
  },
  mounted() {
    (() => {
      this.getExpenseTypes().then(() => {
        this.getBankAccounts().then(() => {
          this.searchClients(this.expense.clientName).then(() => {
            if (this.expense.expenseTypeId === 7) {
              this.getMaterialTypes().then(() => {
                this.updateMaterialCard();
              });
            }
            if (
              this.type !== 'salary' &&
              this.expense.material.materialTypeId === 1
            )
              this.getPaperTypes();
          });
        });
      });

      return Promise.resolve();
    })()
      .then(() => {
        this.loaded = true;
      })
      .catch((error) => {
        this.alertError(error);
      });
  },
  watch: {
    'expense.expenseTypeId': {
      handler(to) {
        if (to === 7) {
          this.getMaterialTypes().then(() => {
            this.updateMaterialCard();
          });
        }
      },
      deep: true,
    },
    materials: {
      handler(to) {
        if (
          !to.find((el) => {
            return el.name === this.expense.material.label;
          })
        ) {
          for (const key of Object.keys(this.expense.material)) {
            if (key !== 'materialTypeId') {
              this.expense.material[key] = null;
            }
          }
        }
      },
    },
    $route: {
      handler() {
        this.hideExpense();
      },
    },
  },
};
</script>

<style scoped>
.contact-persons-table {
  /* max-height: 300px; */
  overflow-y: auto;
}
</style>
